import { render, staticRenderFns } from "./InputNotes.vue?vue&type=template&id=47a2c9d6&"
import script from "./InputNotes.vue?vue&type=script&lang=js&"
export * from "./InputNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports